import React from "react"
import { useTranslation } from "react-i18next"

import Badge from "components/ui/Badge"
import {
  DEBT_UNSOLVED_STAGE,
  DEBT_PAYMENT_SCHEDULE_STAGE,
  DEBT_OVERDUE_STAGE,
  DEBT_COURT_PREPARING_STAGE,
  DEBT_COURT_STAGE,
  DEBT_BAILIFF_STAGE,
} from "config"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  phase: string
}

const BadgeComponent = ({ phase }: Props) => {
  const { t } = useTranslation()

  const isUnsolved = phase === DEBT_UNSOLVED_STAGE
  const isSuccess = [DEBT_PAYMENT_SCHEDULE_STAGE].includes(phase)
  const isError = [
    DEBT_OVERDUE_STAGE,
    DEBT_COURT_PREPARING_STAGE,
    DEBT_COURT_STAGE,
    DEBT_BAILIFF_STAGE,
  ].includes(phase)

  const getBadgeColor = () => {
    if (isSuccess) {
      return "success"
    } else if (isError) {
      return "error"
    } else if (isUnsolved) {
      return "dark"
    } else {
      return "default"
    }
  }

  return (
    <Badge
      tooltip={t(`features.debt.badge.${phase}.tooltip`)}
      color={getBadgeColor()}
    >
      {t(`features.debt.badge.${phase}.title`)}
    </Badge>
  )
}

export default BadgeComponent
